import { Customer } from "../Customer/Customer";
import { OrderAmountReceived } from "./OrderAmountReceived";
import { OrderMockup } from "./OrderMockup";
import { OrderProduct, OrderServices } from "./OrderProduct";
import { Invoice } from "../Invoice/Invoice";
import { NewUser } from "../User";
import { Address } from "../Address/Address";
import { OrderProfitLossStatement } from "./OrderProfitLossStatement";
import { OrderPaymentLinkDetails } from "./OrderPaymentLinkDetails";

export interface OrderBasicDetails {
  id: number;
  type_id?: number;
  type?: string;
  order_notes: string;
  label: string;
  creator_admin_id?: number;
  creator_admin_name?: string;
  editor_admin_name?: string;
  user_id?: number;
  user_first_name?: string;
  user_last_name?: string;
  order_email?: string;
  customer_id?: number;
  customer_name?: string;
  customer?: Customer;
  first_name?: string;
  last_name?: string;
  company_name?: string;
  contact_number?: string;
  status: number;
  amount_before_discount?: number;
  net_amount: number;
  discount: number;
  shipping_quantity: number;
  shipping_amount: number;
  client_po_number?: string;
  client_po_url?: string;
  shipping_amount_tax: number;
  tax_amount: number;
  amount_received: number;
  total_amount: number;
  mockups?: OrderMockup[];
  image_url?: string;
  billing_address_id?: number;
  shipping_address_id?: number;
  expected_delivery_date?: Date;
  tracking_file_url?: string;
  primary_logo_url?: string;
  secondary_logo_url?: string;
  currency: string;
  exchange_rate: number;
  csv_file_url?: string;
  comments?: string;
  duplicated_from_orderid?: number;
  deleted: boolean;
  created_date: Date;
  modified_date: Date;
  inventory_id?: number;
  inventory_type?: number;
  partial_payments?: OrderAmountReceived[];
  billing_address?: Address;
  shipping_address?: Address;
  products?: OrderProduct[];
  services?: OrderServices[];
  gst_no?: string;
  invoices?: Invoice[];
  user?: NewUser;
  discount_percentage?: number;
  project_id?: number;
  invoiced?: boolean;
  proposal_code?: string;
  proposal_url?: string;
  tagged_order_ids?: string;
  brand_name?: string;
  is_paid?: number;
  is_sez?: number;
  international_order?: number;
  monthly_invoicing?: number;
  payment_status: OrderPaymentStatus;
  invoice_status: OrderInvoiceStatus;
  size_mix_url?: string;
  bill_from_address_id?: number;
  bill_from_address?: Address;
  profit_loss_statement?: OrderProfitLossStatement;
  payment_links?: OrderPaymentLinkDetails[] | null;
  is_stock_check_required?: boolean;
}

export enum OrderPaymentStatus {
  PAID = "Paid",
  PARTIALLY_PAID = "Partially Paid",
  UNPAID = "Unpaid",
}

export enum OrderInvoiceStatus {
  INVOICED = "Invoiced",
  PARTIALLY_INVOICED = "Partially Invoiced",
  NOT_INVOICED = "Not Invoiced",
}

export enum OrderStatus {
  CANCELLED = -1,
  LEAD = 0,
  PLACED = 1,
  PI_GENERATED = 2,
  CHANGES_REQUESTED = 3,
  MOCKUP_PENDING = 4,
  MOCKUP_READY = 5,
  MOCKUP_APPROVED = 6,
  IN_DESIGN = 7,
  DESIGN_READY = 8,
  IN_PRODUCTION = 9,
  PRODUCTION_READY = 10,
  SHIPPED = 11,
  DELIVERED = 12,
  COMPLETED = 13,
}

export const orderStatusOptions = [
  { id: "-1", value: "Cancelled" },
  { id: "0", value: "Lead" },
  { id: "1", value: "Placed" },
  { id: "11", value: "Shipped" },
  { id: "12", value: "Delivered" },
  { id: "13", value: "Completed" },
];
